/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { CompanyTemperature } from "./CompanyTemperature";
import {
  CompanyTemperatureFromJSON,
  CompanyTemperatureFromJSONTyped,
  CompanyTemperatureToJSON,
  CompanyTemperatureToJSONTyped,
} from "./CompanyTemperature";
import type { SalesPipelineStage } from "./SalesPipelineStage";
import {
  SalesPipelineStageFromJSON,
  SalesPipelineStageFromJSONTyped,
  SalesPipelineStageToJSON,
  SalesPipelineStageToJSONTyped,
} from "./SalesPipelineStage";
import type { SalesContact } from "./SalesContact";
import {
  SalesContactFromJSON,
  SalesContactFromJSONTyped,
  SalesContactToJSON,
  SalesContactToJSONTyped,
} from "./SalesContact";
import type { ControlsLtlFreight } from "./ControlsLtlFreight";
import {
  ControlsLtlFreightFromJSON,
  ControlsLtlFreightFromJSONTyped,
  ControlsLtlFreightToJSON,
  ControlsLtlFreightToJSONTyped,
} from "./ControlsLtlFreight";
import type { CompanyNoteStoreLatestContact } from "./CompanyNoteStoreLatestContact";
import {
  CompanyNoteStoreLatestContactFromJSON,
  CompanyNoteStoreLatestContactFromJSONTyped,
  CompanyNoteStoreLatestContactToJSON,
  CompanyNoteStoreLatestContactToJSONTyped,
} from "./CompanyNoteStoreLatestContact";
import type { CountryCode } from "./CountryCode";
import {
  CountryCodeFromJSON,
  CountryCodeFromJSONTyped,
  CountryCodeToJSON,
  CountryCodeToJSONTyped,
} from "./CountryCode";
import type { BookingEngagement } from "./BookingEngagement";
import {
  BookingEngagementFromJSON,
  BookingEngagementFromJSONTyped,
  BookingEngagementToJSON,
  BookingEngagementToJSONTyped,
} from "./BookingEngagement";
import type { CompanyProblems } from "./CompanyProblems";
import {
  CompanyProblemsFromJSON,
  CompanyProblemsFromJSONTyped,
  CompanyProblemsToJSON,
  CompanyProblemsToJSONTyped,
} from "./CompanyProblems";

/**
 *
 * @export
 * @interface ListCompaniesRow
 */
export interface ListCompaniesRow {
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  companyName: string;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  leadSource: string;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  utmSource: string;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  utmMedium: string;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  utmCampaign: string;
  /**
   *
   * @type {LocalDate}
   * @memberof ListCompaniesRow
   */
  createdAt: LocalDate;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  paymentTermsDays: number;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  shipmentFrequency: string;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  shipmentFrequencyNote?: string | null;
  /**
   *
   * @type {CompanyTemperature}
   * @memberof ListCompaniesRow
   */
  temperature?: CompanyTemperature | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  quotesRan: number;
  /**
   *
   * @type {LocalDate}
   * @memberof ListCompaniesRow
   */
  firstQuoteDate?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof ListCompaniesRow
   */
  lastQuotedDate?: LocalDate | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  shipmentsBooked: number;
  /**
   *
   * @type {LocalDate}
   * @memberof ListCompaniesRow
   */
  firstBookedDate?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof ListCompaniesRow
   */
  lastBookedDate?: LocalDate | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  winRate: number;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  totalCadSales: number;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesRow
   */
  needsVerification: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesRow
   */
  verificationDenied: boolean;
  /**
   *
   * @type {LocalDate}
   * @memberof ListCompaniesRow
   */
  lastCallDate?: LocalDate | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  lastCallBy?: string | null;
  /**
   *
   * @type {LocalDate}
   * @memberof ListCompaniesRow
   */
  lastSignificantCallDate?: LocalDate | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  lastSignificantCallBy?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  billingAddressLine?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  billingCity?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  billingState?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  billingPostalCode?: string | null;
  /**
   *
   * @type {CountryCode}
   * @memberof ListCompaniesRow
   */
  billingCountry?: CountryCode | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  billingLatitude?: number | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  billingLongitude?: number | null;
  /**
   *
   * @type {ControlsLtlFreight}
   * @memberof ListCompaniesRow
   */
  controlsLtlFreight: ControlsLtlFreight;
  /**
   *
   * @type {LocalDate}
   * @memberof ListCompaniesRow
   */
  snoozeSalesCallsUntil?: LocalDate | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ListCompaniesRow
   */
  associatedProfessionalDomain: Array<string>;
  /**
   *
   * @type {Array<SalesContact>}
   * @memberof ListCompaniesRow
   */
  salesContacts: Array<SalesContact>;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesRow
   */
  overdueSalesCall?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesRow
   */
  isPersonal: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesRow
   */
  hasNonProfessionalDomain: boolean;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  defaultSalesContactId?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ListCompaniesRow
   */
  knownGroupEmailAddresses?: Array<string> | null;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesRow
   */
  isBroker: boolean;
  /**
   *
   * @type {CurrencyCode}
   * @memberof ListCompaniesRow
   */
  currency: CurrencyCode;
  /**
   *
   * @type {Array<string>}
   * @memberof ListCompaniesRow
   */
  companyLabels: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  networkId?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesRow
   */
  hasLinkedCompanies: boolean;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  creditLimit?: number | null;
  /**
   *
   * @type {Array<CompanyProblems>}
   * @memberof ListCompaniesRow
   */
  companyProblems?: Array<CompanyProblems> | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  assignedTo?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ListCompaniesRow
   */
  assignedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  customerSuccessAssignedTo?: string | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  estimatedMonthlyFreightSpend?: number | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesRow
   */
  starReason?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesRow
   */
  isStarred: boolean;
  /**
   *
   * @type {CompanyNoteStoreLatestContact}
   * @memberof ListCompaniesRow
   */
  lastContact?: CompanyNoteStoreLatestContact | null;
  /**
   *
   * @type {CompanyNoteStoreLatestContact}
   * @memberof ListCompaniesRow
   */
  lastSignificantContact?: CompanyNoteStoreLatestContact | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  monthlyLtlCaptureEstimate?: number | null;
  /**
   *
   * @type {SalesPipelineStage}
   * @memberof ListCompaniesRow
   */
  currentSalesPipelineStage?: SalesPipelineStage | null;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesRow
   */
  customerSpecificPricingEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesRow
   */
  apiAccessEnabled: boolean;
  /**
   *
   * @type {BookingEngagement}
   * @memberof ListCompaniesRow
   */
  currentBookingEngagement?: BookingEngagement | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesRow
   */
  bookingOverdueRatio?: number | null;
}

/**
 * Check if a given object implements the ListCompaniesRow interface.
 */
export function instanceOfListCompaniesRow(
  value: object,
): value is ListCompaniesRow {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  if (!("leadSource" in value) || value["leadSource"] === undefined)
    return false;
  if (!("utmSource" in value) || value["utmSource"] === undefined) return false;
  if (!("utmMedium" in value) || value["utmMedium"] === undefined) return false;
  if (!("utmCampaign" in value) || value["utmCampaign"] === undefined)
    return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  if (!("paymentTermsDays" in value) || value["paymentTermsDays"] === undefined)
    return false;
  if (
    !("shipmentFrequency" in value) ||
    value["shipmentFrequency"] === undefined
  )
    return false;
  if (!("quotesRan" in value) || value["quotesRan"] === undefined) return false;
  if (!("shipmentsBooked" in value) || value["shipmentsBooked"] === undefined)
    return false;
  if (!("winRate" in value) || value["winRate"] === undefined) return false;
  if (!("totalCadSales" in value) || value["totalCadSales"] === undefined)
    return false;
  if (
    !("needsVerification" in value) ||
    value["needsVerification"] === undefined
  )
    return false;
  if (
    !("verificationDenied" in value) ||
    value["verificationDenied"] === undefined
  )
    return false;
  if (
    !("controlsLtlFreight" in value) ||
    value["controlsLtlFreight"] === undefined
  )
    return false;
  if (
    !("associatedProfessionalDomain" in value) ||
    value["associatedProfessionalDomain"] === undefined
  )
    return false;
  if (!("salesContacts" in value) || value["salesContacts"] === undefined)
    return false;
  if (!("isPersonal" in value) || value["isPersonal"] === undefined)
    return false;
  if (
    !("hasNonProfessionalDomain" in value) ||
    value["hasNonProfessionalDomain"] === undefined
  )
    return false;
  if (!("isBroker" in value) || value["isBroker"] === undefined) return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("companyLabels" in value) || value["companyLabels"] === undefined)
    return false;
  if (
    !("hasLinkedCompanies" in value) ||
    value["hasLinkedCompanies"] === undefined
  )
    return false;
  if (!("isStarred" in value) || value["isStarred"] === undefined) return false;
  if (
    !("customerSpecificPricingEnabled" in value) ||
    value["customerSpecificPricingEnabled"] === undefined
  )
    return false;
  if (!("apiAccessEnabled" in value) || value["apiAccessEnabled"] === undefined)
    return false;
  return true;
}

export function ListCompaniesRowFromJSON(json: any): ListCompaniesRow {
  return ListCompaniesRowFromJSONTyped(json, false);
}

export function ListCompaniesRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ListCompaniesRow {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    companyName: json["companyName"],
    leadSource: json["leadSource"],
    utmSource: json["utmSource"],
    utmMedium: json["utmMedium"],
    utmCampaign: json["utmCampaign"],
    createdAt: json["createdAt"],
    paymentTermsDays: json["paymentTermsDays"],
    shipmentFrequency: json["shipmentFrequency"],
    shipmentFrequencyNote:
      json["shipmentFrequencyNote"] == null
        ? undefined
        : json["shipmentFrequencyNote"],
    temperature:
      json["temperature"] == null
        ? undefined
        : CompanyTemperatureFromJSON(json["temperature"]),
    quotesRan: json["quotesRan"],
    firstQuoteDate:
      json["firstQuoteDate"] == null ? undefined : json["firstQuoteDate"],
    lastQuotedDate:
      json["lastQuotedDate"] == null ? undefined : json["lastQuotedDate"],
    shipmentsBooked: json["shipmentsBooked"],
    firstBookedDate:
      json["firstBookedDate"] == null ? undefined : json["firstBookedDate"],
    lastBookedDate:
      json["lastBookedDate"] == null ? undefined : json["lastBookedDate"],
    winRate: json["winRate"],
    totalCadSales: json["totalCadSales"],
    needsVerification: json["needsVerification"],
    verificationDenied: json["verificationDenied"],
    lastCallDate:
      json["lastCallDate"] == null ? undefined : json["lastCallDate"],
    lastCallBy: json["lastCallBy"] == null ? undefined : json["lastCallBy"],
    lastSignificantCallDate:
      json["lastSignificantCallDate"] == null
        ? undefined
        : json["lastSignificantCallDate"],
    lastSignificantCallBy:
      json["lastSignificantCallBy"] == null
        ? undefined
        : json["lastSignificantCallBy"],
    billingAddressLine:
      json["billingAddressLine"] == null
        ? undefined
        : json["billingAddressLine"],
    billingCity: json["billingCity"] == null ? undefined : json["billingCity"],
    billingState:
      json["billingState"] == null ? undefined : json["billingState"],
    billingPostalCode:
      json["billingPostalCode"] == null ? undefined : json["billingPostalCode"],
    billingCountry:
      json["billingCountry"] == null
        ? undefined
        : CountryCodeFromJSON(json["billingCountry"]),
    billingLatitude:
      json["billingLatitude"] == null ? undefined : json["billingLatitude"],
    billingLongitude:
      json["billingLongitude"] == null ? undefined : json["billingLongitude"],
    controlsLtlFreight: ControlsLtlFreightFromJSON(json["controlsLtlFreight"]),
    snoozeSalesCallsUntil:
      json["snoozeSalesCallsUntil"] == null
        ? undefined
        : json["snoozeSalesCallsUntil"],
    associatedProfessionalDomain: json["associatedProfessionalDomain"],
    salesContacts: (json["salesContacts"] as Array<any>).map(
      SalesContactFromJSON,
    ),
    overdueSalesCall:
      json["overdueSalesCall"] == null ? undefined : json["overdueSalesCall"],
    isPersonal: json["isPersonal"],
    hasNonProfessionalDomain: json["hasNonProfessionalDomain"],
    defaultSalesContactId:
      json["defaultSalesContactId"] == null
        ? undefined
        : json["defaultSalesContactId"],
    knownGroupEmailAddresses:
      json["knownGroupEmailAddresses"] == null
        ? undefined
        : json["knownGroupEmailAddresses"],
    isBroker: json["isBroker"],
    currency: CurrencyCodeFromJSON(json["currency"]),
    companyLabels: json["companyLabels"],
    networkId: json["networkId"] == null ? undefined : json["networkId"],
    hasLinkedCompanies: json["hasLinkedCompanies"],
    creditLimit: json["creditLimit"] == null ? undefined : json["creditLimit"],
    companyProblems:
      json["companyProblems"] == null
        ? undefined
        : (json["companyProblems"] as Array<any>).map(CompanyProblemsFromJSON),
    assignedTo: json["assignedTo"] == null ? undefined : json["assignedTo"],
    assignedAt: json["assignedAt"] == null ? undefined : json["assignedAt"],
    customerSuccessAssignedTo:
      json["customerSuccessAssignedTo"] == null
        ? undefined
        : json["customerSuccessAssignedTo"],
    estimatedMonthlyFreightSpend:
      json["estimatedMonthlyFreightSpend"] == null
        ? undefined
        : json["estimatedMonthlyFreightSpend"],
    starReason: json["starReason"] == null ? undefined : json["starReason"],
    isStarred: json["isStarred"],
    lastContact:
      json["lastContact"] == null
        ? undefined
        : CompanyNoteStoreLatestContactFromJSON(json["lastContact"]),
    lastSignificantContact:
      json["lastSignificantContact"] == null
        ? undefined
        : CompanyNoteStoreLatestContactFromJSON(json["lastSignificantContact"]),
    monthlyLtlCaptureEstimate:
      json["monthlyLtlCaptureEstimate"] == null
        ? undefined
        : json["monthlyLtlCaptureEstimate"],
    currentSalesPipelineStage:
      json["currentSalesPipelineStage"] == null
        ? undefined
        : SalesPipelineStageFromJSON(json["currentSalesPipelineStage"]),
    customerSpecificPricingEnabled: json["customerSpecificPricingEnabled"],
    apiAccessEnabled: json["apiAccessEnabled"],
    currentBookingEngagement:
      json["currentBookingEngagement"] == null
        ? undefined
        : BookingEngagementFromJSON(json["currentBookingEngagement"]),
    bookingOverdueRatio:
      json["bookingOverdueRatio"] == null
        ? undefined
        : json["bookingOverdueRatio"],
  };
}

export function ListCompaniesRowToJSON(json: any): ListCompaniesRow {
  return ListCompaniesRowToJSONTyped(json, false);
}

export function ListCompaniesRowToJSONTyped(
  value?: ListCompaniesRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    companyName: value["companyName"],
    leadSource: value["leadSource"],
    utmSource: value["utmSource"],
    utmMedium: value["utmMedium"],
    utmCampaign: value["utmCampaign"],
    createdAt: value["createdAt"],
    paymentTermsDays: value["paymentTermsDays"],
    shipmentFrequency: value["shipmentFrequency"],
    shipmentFrequencyNote: value["shipmentFrequencyNote"],
    temperature: CompanyTemperatureToJSON(value["temperature"]),
    quotesRan: value["quotesRan"],
    firstQuoteDate: value["firstQuoteDate"],
    lastQuotedDate: value["lastQuotedDate"],
    shipmentsBooked: value["shipmentsBooked"],
    firstBookedDate: value["firstBookedDate"],
    lastBookedDate: value["lastBookedDate"],
    winRate: value["winRate"],
    totalCadSales: value["totalCadSales"],
    needsVerification: value["needsVerification"],
    verificationDenied: value["verificationDenied"],
    lastCallDate: value["lastCallDate"],
    lastCallBy: value["lastCallBy"],
    lastSignificantCallDate: value["lastSignificantCallDate"],
    lastSignificantCallBy: value["lastSignificantCallBy"],
    billingAddressLine: value["billingAddressLine"],
    billingCity: value["billingCity"],
    billingState: value["billingState"],
    billingPostalCode: value["billingPostalCode"],
    billingCountry: CountryCodeToJSON(value["billingCountry"]),
    billingLatitude: value["billingLatitude"],
    billingLongitude: value["billingLongitude"],
    controlsLtlFreight: ControlsLtlFreightToJSON(value["controlsLtlFreight"]),
    snoozeSalesCallsUntil: value["snoozeSalesCallsUntil"],
    associatedProfessionalDomain: value["associatedProfessionalDomain"],
    salesContacts: (value["salesContacts"] as Array<any>).map(
      SalesContactToJSON,
    ),
    overdueSalesCall: value["overdueSalesCall"],
    isPersonal: value["isPersonal"],
    hasNonProfessionalDomain: value["hasNonProfessionalDomain"],
    defaultSalesContactId: value["defaultSalesContactId"],
    knownGroupEmailAddresses: value["knownGroupEmailAddresses"],
    isBroker: value["isBroker"],
    currency: CurrencyCodeToJSON(value["currency"]),
    companyLabels: value["companyLabels"],
    networkId: value["networkId"],
    hasLinkedCompanies: value["hasLinkedCompanies"],
    creditLimit: value["creditLimit"],
    companyProblems:
      value["companyProblems"] == null
        ? undefined
        : (value["companyProblems"] as Array<any>).map(CompanyProblemsToJSON),
    assignedTo: value["assignedTo"],
    assignedAt: value["assignedAt"],
    customerSuccessAssignedTo: value["customerSuccessAssignedTo"],
    estimatedMonthlyFreightSpend: value["estimatedMonthlyFreightSpend"],
    starReason: value["starReason"],
    isStarred: value["isStarred"],
    lastContact: CompanyNoteStoreLatestContactToJSON(value["lastContact"]),
    lastSignificantContact: CompanyNoteStoreLatestContactToJSON(
      value["lastSignificantContact"],
    ),
    monthlyLtlCaptureEstimate: value["monthlyLtlCaptureEstimate"],
    currentSalesPipelineStage: SalesPipelineStageToJSON(
      value["currentSalesPipelineStage"],
    ),
    customerSpecificPricingEnabled: value["customerSpecificPricingEnabled"],
    apiAccessEnabled: value["apiAccessEnabled"],
    currentBookingEngagement: BookingEngagementToJSON(
      value["currentBookingEngagement"],
    ),
    bookingOverdueRatio: value["bookingOverdueRatio"],
  };
}
